import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["ariaLabel", "disabled", "id", "isActionIcon", "isActive", "leftAvatar", "leftIcon", "focused", "hovered", "keyboardFocused", "onBlur", "onClick", "onFocus", "onMouseDown", "onMouseOut", "onMouseOver", "onMouseUp", "onPress", "onPressIn", "onPressOut", "onTouchEnd", "onTouchStart", "pressed", "rightAvatar", "rightIcon", "tabIndex", "testID", "title", "UNSAFE_touchableProps"];
import React from 'react';
import { isNative } from '@bubble-ui/util-platform';
import View from '@bubble-ui/primitive-view';
import Text from '@bubble-ui/primitive-text';
import Touchable from '@bubble-ui/primitive-touchable';
import { DesignContextForwardProvider, useDesignContext } from '@klarna/designtokens';
import { useInteractiveStateCombined } from '@bubble-ui/hook-use-interactive-state';
import { usePropsSpreadingDeprecationWarning } from '@bubble-ui/hook-use-props-spreading-deprecation-warning';
import { defaultDesignTokens } from './defaultDesignTokens';
import { getDefaultStyleSheet } from './getDefaultStyleSheet';
var Chip = _ref => {
  var {
      ariaLabel,
      disabled = false,
      id,
      isActionIcon,
      isActive,
      leftAvatar,
      leftIcon: LeftIcon,
      focused,
      hovered,
      keyboardFocused,
      onBlur,
      onClick,
      onFocus,
      onMouseDown,
      onMouseOut,
      onMouseOver,
      onMouseUp,
      onPress,
      onPressIn,
      onPressOut,
      onTouchEnd,
      onTouchStart,
      pressed,
      rightAvatar,
      rightIcon: RightIcon,
      tabIndex,
      testID,
      title,
      UNSAFE_touchableProps
      /**
       * @deprecated props spreading is outdated and will be removed with v7.0.0
       */
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  usePropsSpreadingDeprecationWarning({
    componentName: 'Chip',
    props,
    useInstead: 'UNSAFE_touchableProps',
    removalDate: 'v7.0.0'
  });
  var [interactiveState, eventHandlers] = useInteractiveStateCombined({
    disabled,
    focused,
    hovered,
    keyboardFocused,
    onBlur,
    onFocus,
    onMouseDown,
    onMouseOut,
    onMouseOver,
    onMouseUp,
    onPressIn,
    onPressOut,
    onTouchEnd,
    onTouchStart,
    pressed
  });
  var designContext = useDesignContext(defaultDesignTokens);
  var {
    buttonStyle,
    keyboardFocusStyle,
    rootStyle,
    iconColor,
    avatarProps,
    textStyle,
    textWrapperStyle
  } = getDefaultStyleSheet({
    designContext,
    interactiveState: interactiveState.interactiveState,
    isActionIcon,
    isActive,
    leftAvatar,
    LeftIcon,
    rightAvatar,
    RightIcon
  });
  return /*#__PURE__*/React.createElement(Touchable, _extends({
    id: id
  }, UNSAFE_touchableProps, {
    ariaLabel: ariaLabel,
    disabled: interactiveState.disabled,
    onClick: onClick,
    onPress: onPress,
    style: buttonStyle,
    tabIndex: tabIndex,
    testID: testID
  }, props, eventHandlers), /*#__PURE__*/React.createElement(View, {
    style: rootStyle
  }, interactiveState.keyboardFocused && /*#__PURE__*/React.createElement(View, {
    style: keyboardFocusStyle
  }), /*#__PURE__*/React.isValidElement(leftAvatar) ? /*#__PURE__*/React.cloneElement(leftAvatar, avatarProps) : LeftIcon ? /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(DesignContextForwardProvider, {
    context: designContext
  }, /*#__PURE__*/React.createElement(LeftIcon, iconColor))) : null, /*#__PURE__*/React.createElement(View, {
    style: textWrapperStyle
  }, /*#__PURE__*/React.createElement(Text, _extends({
    style: textStyle
  }, isNative ? {
    numberOfLines: 1,
    ellipsizeMode: 'tail'
  } : {}), title)), /*#__PURE__*/React.isValidElement(rightAvatar) ? /*#__PURE__*/React.cloneElement(rightAvatar, avatarProps) : RightIcon ? /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(DesignContextForwardProvider, {
    context: designContext
  }, /*#__PURE__*/React.createElement(RightIcon, iconColor))) : null));
};
Chip.displayName = 'Chip';
export default Chip;
//# sourceMappingURL=index.js.map